module.exports = __webpack_public_path__ + "media/bootstrap-icons/save2-fill-ee83f0c2.svg";